import $ from "jquery";
import { FormValidator } from "./contact-form/validator";
import { ContactData, MediatorSubmitter } from "./contact-form/submit-data";
import WpaCode from "../wpacode/wpacode";

$(() => {
    const $form = $('#generali-mediator-contact-form');

    $form.on('submit', async function (event) {
        event.preventDefault();
        const $this = $(this);
        const validator = new FormValidator($this);
        const errors = validator.validateAll();
        const $formContent = $this.find('.form-content');
        const $formSuccess = $this.find('.form-success');

        if (errors > 0) {
            return;
        }

        try {
            let mediatorCode = $this.find('input[name="mediatorCode"]').val();
            const wpacode = WpaCode.getCurrent();
            // if the input is empty and wpacode exists, get the current code
            if (!mediatorCode && wpacode instanceof WpaCode) {
                mediatorCode = wpacode.getCode();
            }

            const contactData = new ContactData(
                mediatorCode,
                $this.find('input[name="nameContact"]').val(),
                $this.find('input[name="nifContact"]').val(),
                $this.find('input[name="tlfEmailContact"]').val()
            );
            // submit the contact data to the webservice
            const submitter = new MediatorSubmitter(contactData);
            await submitter.submit();

            $formContent.hide();
            $formSuccess.show();
        } catch (error) {
            console.log(error);
        }
    });

    $('[data-target-accordion]').on('click', function (event) {
       event.preventDefault();
       const $this = $(this);
       const $accordion = $($this.data('target-accordion'));

       $accordion.toggleClass('cmp-accordion-hide', !$($this.data('target-accordion')).hasClass('cmp-accordion-hide'));
    });

    $('[data-read-more]').on('click', function (event) {
        event.preventDefault();
        const $this = $(this);
        const $label = $($this.data('read-more'));
        const content = $label.data('content');
        const $contentElement = $($label.data('content-target'));

        $contentElement.text(content);
        $('[data-read-less]').show();
        $this.hide();
    });

    $('[data-read-less]').on('click', function (event) {
        event.preventDefault();
        const $this = $(this);
        const $label = $($this.data('read-less'));
        const content = $label.data('content-limit');
        const $contentElement = $($label.data('content-target'));

        $contentElement.text(content);
        $('[data-read-more]').show();
        $this.hide();
    });

    $('[data-modal="modal-agent-contact"]').on('click', function () {
        $('#generali-mediator-contact-form').find('input').each(function () {
            const $this = $(this);

            if ($this.attr('type') === 'checkbox') {
                $this.prop('checked', false);
            } else {
                $this.val('');
            }
        });

        $('#generali-mediator-contact-form .form-content').show();
        $('#generali-mediator-contact-form .form-success').hide();
    });
});